import axios from "axios";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { FiPlus as PlusIcon } from "react-icons/fi";
import { NotificationManager } from "react-notifications";
import { useParams } from "react-router-dom";
import UpdateTab from "../../../components/DetailTabsData/UpdateTab";
import ActivityFilter from "../../../components/FilterComponents/ActivityFilter";
import { useSelectedOptions } from "../../../context/selectedOptionsContext";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import AddActivityModal from "../../Companies/Modals/AddActivityModal";

const UpdateTabData = ({ parentLoading }) => {
  const { id } = useParams();
  const [config] = useAuth();
  const containerRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [activityData, setActivityData] = useState([]);
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [filterData, setFilterData] = useState({ type: "alltime", startDate: "", endDate: "" });
  const { isactivityDataSentSuccessfully, setIsactivityDataSentSuccessfully } = useSelectedOptions();
  const { isDeletedactivity, isEditedactivity, setIsDeletedactivity, setIsEditedactivity } = useSelectedOptions();

  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;
      if (!container) return;

      const { scrollTop, scrollHeight, clientHeight } = container;

      if (scrollTop + clientHeight >= scrollHeight - 10) {
        if (loading || !hasMore) return;
        setPageNumber(pageNumber + 1);
        fetchActivityList(pageNumber + 1);
      }
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [loading, hasMore]);

  const buildQueryParams = () => {
    let params = `id=${id}&list_type=contact&date=${filterData?.type}&activity=${selectedActivities}`;
    if (filterData?.type === "custom") {
      params += `&from_date=${moment(filterData.startDate).format("DD/MM/YYYY")}&to_date=${moment(filterData.endDate).format("DD/MM/YYYY")}`;
    }
    return params;
  };

  const fetchActivityList = (page) => {
    setLoading(true);
    const queryParams = buildQueryParams();
    axios
      .get(`${BASE_URL}/activity-list/?page=${page}&per_page=${itemPerPage}&${queryParams}`, config)
      .then((res) => {
        const data = res?.data?.data;
        if (data?.length === 0) {
          setHasMore(false);
        } else {
          setHasMore(data?.has_more);
          setActivityData((prevItems) => [...prevItems, ...data?.activities]);
        }
        setIsDeletedactivity(false);
        setIsEditedactivity(false);
        setIsactivityDataSentSuccessfully(false);
      })
      .catch((err) => {
        setActivityData([]);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  const onSuccess = () => {
    setActivityData([]);
    fetchActivityList(1);
  };

  useEffect(() => {
    if (filterData?.type !== "custom") {
      onSuccess();
    }
  }, [isactivityDataSentSuccessfully, isDeletedactivity, isEditedactivity, selectedActivities, filterData, id]);

  return (
    <div>
      <div className="flex justify-between items-start head-5 green-H">
        <ActivityFilter
          filterData={filterData}
          onSuccess={onSuccess}
          onSetFilterData={(value) => {
            setFilterData(value);
          }}
          selectedActivities={selectedActivities}
          onSetSelectedActivities={(value) => setSelectedActivities(value)}
        />

        <p className="head-5 green-H flex items-center gap-1" role="button" onClick={() => setShowModal(true)}>
          <PlusIcon /> Add Activity
        </p>
      </div>

      <div ref={containerRef} className="mt-6 md:px-16 overflow-x-hidden h-[60vh]">
        <UpdateTab activitydata={activityData} loading={loading} hasMore={hasMore} parentLoading={parentLoading} />
      </div>

      <AddActivityModal from="contact" showContact={false} showModal={showModal} onClose={() => setShowModal(false)} onSuccess={onSuccess} />
    </div>
  );
};

export default UpdateTabData;
